import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

export const largeTextStyles = {
  largeTextStylesFontOnWhite: {
    fontFamily: "'Noto Sans HK', sans-serif",
    fontSize: 16,
    fontWeight: 400,
    color: '#484848',
    lineHeight: '26px',
    margin: 0,
    padding: 0,
  },
  largeTextStylesFontOnGreen: {
    fontFamily: "'Noto Sans HK', sans-serif",
    fontSize: 16,
    fontWeight: 400,
    color: '#000',
    lineHeight: '26px',
    margin: 0,
    padding: 0,
  },
};

const useStyles = makeStyles(() => largeTextStyles);

const LargeText = (props) => {
  const { className, onGreen, ...otherProps } = props;
  const classes = useStyles();

  return (
    <Typography
      className={classNames([
        onGreen ? classes.largeTextStylesFontOnGreen : classes.largeTextStylesFontOnWhite,
        className,
      ])}
      component="p"
      {...otherProps}>
      {props.children}
    </Typography>
  );
};

LargeText.propTypes = {
  onGreen: PropTypes.bool,
};

export default LargeText;
